import { ClinTheme } from '../ClinTheme'

const pageWidth = (): number =>
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth

export const isMobile = () => pageWidth() <= ClinTheme.breakpoints[0]
